import { render } from "./Profile.vue?vue&type=template&id=41f059d8&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=41f059d8&lang=scss&scoped=true"

import exportComponent from "D:\\Front-end\\vuechat\\app-ua-truth-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f059d8"]])

export default __exports__